/**
 * Store Pinia pour gérer les dialogues globaux dans l'application.
 *
 * Fournit des méthodes pour :
 * - openDialog : ouvrir un dialogue avec du contenu spécifique.
 * - closeDialog : fermer le dialogue et réinitialiser le contenu et le titre.
 *
 * Références externes :
 * - content : contient le contenu actuel du dialogue.
 * - visible : état de visibilité du dialogue.
 * - globalHeaderTitleLayout : titre affiché dans l'en-tête du dialogue.
 */
import { defineStore } from 'pinia';
import {
  content,
  globalHeaderTitleLayout,
  isGlobalError,
  visible,
} from '@/refs/common.refs';
import { isAtcivatedWatch } from '@/refs/commerce.refs';

export const useDialogStore = defineStore('dialog', () => {
  /**
   * Ouvre le dialogue et définit son contenu.
   * @param data - Contenu à afficher dans le dialogue
   */
  const openDialog = (data: typeof content.value) => {
    content.value = data;
    visible.value = true;
  };

  /**
   * Ferme le dialogue et réinitialise le contenu et le titre.
   */
  const closeDialog = () => {
    isGlobalError.value = false;
    isAtcivatedWatch.value = !isAtcivatedWatch.value;
    globalHeaderTitleLayout.value = 'Informations supplémentaires';
    visible.value = false;
    content.value = null;
  };

  return { visible, content, openDialog, closeDialog };
});
